export enum RendererType {
    Default = "defaultRenderer",
    DueDate = "dueDateRenderer",
    Progress = "progressRenderer",
    Score = "scoreRenderer",
    Icon = "iconRenderer",
}
